import { environment } from "services/environment/Environment";
import { getAccessToken } from "store/state";

type Method = "GET" | "POST" | "PUT" | "DELETE";

interface ApiClientOptions<T> {
  method: Method;
  url: string;
  body?: T;
  params?: Record<string, any>;
  withContentType?: boolean;
  customContentType?: string;
  withoutVersion?: boolean;
  headers?: Record<string, string>; // <-- dodane
}

const apiClient = async <T>({
  method,
  url,
  body,
  params,
  withContentType = true,
  customContentType,
  withoutVersion = false,
  headers: customHeaders = {}, // <-- dodane
}: ApiClientOptions<T>) => {
  const token = getAccessToken();
  const baseURL = environment().api.apiUrl;

  let fullUrl = (withoutVersion ? baseURL.replace('v1/', '') : baseURL) + url;

  if (params) {
    const queryParams = new URLSearchParams(params).toString();
    fullUrl += `?${queryParams}`;
  }

  const defaultHeaders = {
    Accept: "*/*",
    Authorization: `Bearer ${token}`,
    ...customHeaders,
  };

  const headers = withContentType
    ? {
        "Content-Type": customContentType ?? "application/json",
        ...defaultHeaders,
        ...customHeaders,
      }
    : {
        ...defaultHeaders,
        ...customHeaders,
      };

  const requestOptions: RequestInit = {
    method,
    headers,
    body:
      !withContentType || !!customContentType?.length
        ? (body as any)
        : JSON.stringify(body),
  };

  const response = await fetch(fullUrl, requestOptions);
  return response;
};

export default apiClient;
